import { firebaseDb } from './index'

export const saveOwner = (dispatch, onOwnerSaved, projectId, owner ) => {
  const id = owner.id
  delete owner.id
  firebaseDb().ref(`owners/${projectId}/${id}`).set(owner)
    .then(() => {
      dispatch(onOwnerSaved(projectId, id, owner))
    })
    .catch((error) => {
      console.log(error)
    })
}

export const deleteOwner = (dispatch, onOwnerDeleted, projectId, ownerId ) => {
  firebaseDb().ref(`owners/${projectId}/${ownerId}`).set(null)
    .then(() => {
      dispatch(onOwnerDeleted(projectId, ownerId))
    })
    .catch((error) => {
      console.log(error)
    })
}

export const deleteOwners = (dispatch, onOwnersDeleted, projectId, ownersIds ) => {
  let updates = {}
  for (let i = 0; i < ownersIds.length; i++) {
    updates[`owners/${projectId}/${ownersIds[i]}`] = null
  }
  firebaseDb().ref().update(updates)
    .then(() => {
      dispatch(onOwnersDeleted(projectId, ownersIds))
    })
    .catch((error) => {
      console.log(error)
    })
}



// WEBPACK FOOTER //
// ./src/Firebase/apiOwners.js